import { format, parseISO } from "date-fns";

/**
 * Formats a date to ISO string (YYYY-MM-DD)
 */
export const formatDateToISO = (date: Date | null): string => {
	if (!date) return "";
	return format(date, "yyyy-MM-dd");
};

/**
 * Parses an ISO date string to Date object
 */
export const parseISODate = (dateString: string): Date => {
	return parseISO(dateString);
};

/**
 * Formats a date for display
 */
export const formatDateForDisplay = (date: Date | null): string => {
	if (!date) return "";
	return format(date, "MMM dd, yyyy");
};

/**
 * Validates that end date is after start date
 */
export const validateDateRange = (
	startDate: Date | null,
	endDate: Date | null
): boolean => {
	if (!startDate || !endDate) return true;
	return endDate >= startDate;
};
